"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.VideoOverlay = exports.VideoPlayer = exports.VideoBox = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _reactPlayer = _interopRequireDefault(require("react-player"));
/*
 *  Turn `16:9` into `9 / 16` into `56.25%`
 *  Turn `4:3` into `3 / 4` into `75%`
 */


var ratioToPercent = function ratioToPercent(aspectRatio) {
  if (aspectRatio) {
    var _aspectRatio$split$ma = aspectRatio.split(':').map(function (num) {
      return Number(num);
    }),
        _aspectRatio$split$ma2 = _slicedToArray(_aspectRatio$split$ma, 2),
        w = _aspectRatio$split$ma2[0],
        h = _aspectRatio$split$ma2[1];

    return "".concat(h / w * 100, "%");
  }

  return '56.25%';
};

var VideoBox = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var aspectRatio = _ref.aspectRatio,
      height = _ref.height;
  return {
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden',
    paddingTop: ratioToPercent(aspectRatio),
    height: height || 0,
    iframe: {
      // this is added to provide the cinematic aspect when the
      // provided Aspect ratio does not match the one in the video
      background: 'black'
    }
  };
});
exports.VideoBox = VideoBox;
var VideoPlayer = (0, _styled.default)(_reactPlayer.default)(function (props) {
  return {
    position: 'absolute',
    left: 0,
    top: 0,
    transform: "scale(".concat(props.zoom, ")"),
    video: {
      objectFit: 'cover'
    }
  };
});
exports.VideoPlayer = VideoPlayer;
var VideoOverlay = (0, _styled.default)('div')(function () {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
});
exports.VideoOverlay = VideoOverlay;